<form [formGroup]="formGroup">
  <div class="to-box">
    <p class="body2 semibold to-label">{{boxLabel}}:</p>

    <div class="chip-container">
      @for (recipientBoxChip of formGroup.controls.recipientBoxChips.value; track recipientBoxChip.id) {
        <span class="contact-chip">
          <span class="chip-text">
            <span>{{recipientBoxChip.description}}</span>
            @if (recipientBoxChip.type != chipType.AdditionalEmail) {
              <span> &lt;{{recipientBoxChip.emailAddress}}&gt;</span>
            }
          </span>
          <button type="button" class="button-reset" [attr.aria-label]="sysText.remove_ariaLabel" (click)="onRemoveRecipient(recipientBoxChip)">
            <mat-icon>close</mat-icon>
          </button>
        </span>
      }
    </div>
  </div>

  <mat-error class="error" aria-live="polite">{{ formGroup.errors?.msError }}</mat-error>

  <div class="select-container">
    <mat-icon [ngClass]="{ focus: select.focused }">contact_mail</mat-icon>

    <mat-form-field color="accent">
      <mat-label>{{ sysText.sendNewEmailDialog_relevantContacts }}</mat-label>

      <mat-select
        #select="matSelect"
        [formControl]="formGroup.controls.relevantRecipientOptions"
        multiple
        (selectionChange)="onSelectionChangeRelevantRecipient($event)"
        panelWidth="fit-content">

        <mat-select-trigger>
          @if (formGroup.controls.relevantRecipientOptions.value?.length >= 1) {
            <span>
              @for (rrid of formGroup.controls.relevantRecipientOptions.value; track rrid; let i = $index) {
                <span>
                  <span>{{ (rrid | findfromid : dialogData.relevantRecipientOptions : sysText).description }}</span>
                  <span> &bull;&nbsp;{{ (rrid | findfromid : dialogData.relevantRecipientOptions : sysText).relevantContextName }}</span>
                  <span> &bull;&nbsp;{{ (rrid | findfromid : dialogData.relevantRecipientOptions : sysText).emailAddressTypeName }}</span>
                  @if (i !== formGroup.controls.relevantRecipientOptions.value?.length - 1) {
                    <span>, </span>
                  }
                </span>
              }
            </span>
          }
        </mat-select-trigger>

        @for (contact of dialogData.relevantRecipientOptions; track contact) {
          <mat-option [value]="contact.id + '.' + contact.relevantContextId + '.' + contact.emailAddressTypeId">
            <span>{{ contact.description }}</span>
            <span> &bull;&nbsp;{{ sysText["relevantContext" + contact.relevantContextId] }}</span>
            <span> &bull;&nbsp;{{ sysText["emailAddressType" + contact.emailAddressTypeId] }}</span>
            <p class="recipient-email">{{ contact.emailAddress }}</p>
          </mat-option>
        }
      </mat-select>

      <!-- mat hint for spacing -->
      <mat-hint></mat-hint>
      <mat-error></mat-error>
    </mat-form-field>
  </div>

  <app-autocomplete-field
    [group]="formGroup"
    [control]="formGroup.controls.employeeRecipientOptionAdd"
    [icon]="'account_circle'"
    [label]="sysText.sendNewEmailDialog_allContacts"
    [options]="dialogData.employeeRecipientOptions"
    [showSearchIcon]="true"
    (optionSelect)="onOptionSelectEmployeeRecipientAdd()">
  </app-autocomplete-field>

  <div class="add-email-container">
    <!-- Enter in the field adds the address, like the add button -->
    <app-input-field
      class="add-email-field"
      [group]="formGroup"
      [control]="formGroup.controls.additionalEmailAddressAdd"
      [icon]="'alternate_email'"
      [label]="sysText.sendNewEmailDialog_additionalEmailAddresses"
      (keydown.enter)="onAddEmail()">
    </app-input-field>

    <button
      type="button"
      mat-icon-button
      [attr.aria-label]="sysText.add_ariaLabel"
      (click)="onAddEmail()"
      class="add-button">
      <mat-icon class="button-icon">add_circle</mat-icon>
    </button>
  </div>
</form>